import { render, staticRenderFns } from "./controlPage.vue?vue&type=template&id=f2533b4c&scoped=true"
import script from "./controlPage.vue?vue&type=script&lang=js"
export * from "./controlPage.vue?vue&type=script&lang=js"
import style0 from "./controlPage.vue?vue&type=style&index=0&id=f2533b4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2533b4c",
  null
  
)

export default component.exports